export const HeaderImage={
    "mobilier": `${process.env.PUBLIC_URL}/assets/categorie/6.svg`,
    "matelas":`${process.env.PUBLIC_URL}/assets/categorie/3.svg`,
    "oxygénothérapie":`${process.env.PUBLIC_URL}/assets/categorie/1.svg`,
    "diagnostics":`${process.env.PUBLIC_URL}/assets/categorie/4.svg`,
    "aide a la marche":`${process.env.PUBLIC_URL}/assets/categorie/7.svg`,
    "radiologie":`${process.env.PUBLIC_URL}/assets/categorie/5.svg`,
    "anatomie":`${process.env.PUBLIC_URL}/assets/categorie/2.svg`,
    "consommable":`${process.env.PUBLIC_URL}/assets/categorie/8.jpg`,
}